export {
  default as shower,
  ReactComponent as Shower,
} from '@assets/icons/features-and-amenities/shower.svg'    
